import React, { useState } from 'react';
import Container from '@mui/material/Container';
import DetailIcon from '@mui/icons-material/FindInPage';
import Header from '../../../components/Header/Header';
import Title from '../../../components/Title/Title';
import DataTable from '../../../components/DataTable/DataTable';
import TableButton from '../../../components/TableButton/TableButton';
import ContractDetails from './ContractDetails';
import * as config from './../../../config';

const Contracts = () => {
    const [detailId, setDetailId] = useState(null);
    const [detailDialog, setDetailDialog] = useState(false);

    const handleDetailDialogOpen = (id) => {
        setDetailId(id);
        setDetailDialog(true);
    };

    const handleDetailDialogClose = () => {
        setDetailDialog(false);
    };

    const formatActions = (data) => {
        return (
            <TableButton
                preset="blue"
                onClick={() => handleDetailDialogOpen(data.row.id)}
            >
                <DetailIcon />
                Details
            </TableButton>
        );
    };

    const columns = [
        {
            id: 'issuer',
            label: 'Issuer',
            format: { type: 'text' },
            align: 'left',
            width: '20%',
        },
        {
            id: 'title',
            label: 'Title',
            format: { type: 'text' },
            align: 'left',
            width: '35%',
        },
        {
            id: 'published_on',
            label: 'Date Published',
            format: { type: 'date', format: 'date' },
            width: '15%',
        },
        {
            id: 'signed_on',
            label: 'Date Signed',
            format: { type: 'date', format: 'date' },
            width: '15%',
        },
        {
            id: 'actions',
            label: 'Actions',
            format: { type: 'custom', formatter: formatActions },
            width: '15%',
            sortDisabled: true,
        },
    ];

    return (
        <React.Fragment>
            <Header />
            <Title text="Contracts" />
            <Container>
                <DataTable
                    dataColumns={columns}
                    remoteUrl={`${config.API_BASE_URL}/contract/list`}
                    enableSearch
                    enableExport
                    autoLayout
                />
            </Container>
            <ContractDetails
                open={detailDialog}
                id={detailId}
                onClose={handleDetailDialogClose}
            />
        </React.Fragment>
    );
};

export default Contracts;
